export default ({
  namespaced: true,
  state: {
    view: 'snackbarButton',
    defaultValues: {text: '', color: 'info', buttonText: 'Finalizar Subtarefas', buttonFunction: function () {}, dialog: false, buttonColor: 'info', timeout: 12000},
    values: {}
  },
  getters: {
    values: state => {
      return state.values
    }
  },
  mutations: {
    change_values (state, payload) {
      state.values = JSON.parse(JSON.stringify(state.defaultValues))
      Object.assign(state.values, payload)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/snackbarButton.js